import React, { useRef } from 'react';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import EDView from '../../BaseComponents/View/EDView';
import EDPopover from '../../BaseComponents/Popover/EDPopover';
import { useToggle } from '../../Hooks/booleanHooks';
import ServerErrorView from './ServerErrorView';
import { GraphQLError } from 'graphql';
import { makeStyles } from 'tss-react/mui';
import EDTooltip from '../../BaseComponents/Tooltip/EDTooltip';

interface IProps {
  errors: readonly GraphQLError[];
  caption: string;
  errorMessage: string;
}

const useStyles = makeStyles()(
  theme =>
    ({
      mainContainer: {
        width: '100%',
      },
      caption: {
        width: 'min-content',
        color: theme.palette.error.main,
        cursor: 'pointer',
        '&:hover': {
          borderBottom: `1px solid ${theme.palette.error.main}`,
          marginBottom: -1,
        },
      },
      container: {
        padding: 16,
      },
    } as const)
);

const ServerErrorSimple: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes } = useStyles();
  const anchorEl = useRef(null);
  const [open, toggleOpen] = useToggle();
  return (
    <EDView className={classes.mainContainer}>
      <EDTooltip title="Visa error">
        <EDTypography
          onClick={toggleOpen}
          ref={anchorEl}
          className={classes.caption}
          bold
        >
          {props.caption}
        </EDTypography>
      </EDTooltip>
      <EDPopover
        anchorEl={anchorEl.current}
        open={open}
        onClose={toggleOpen}
        classes={{ paper: classes.container }}
      >
        {props.errors.map((error, i) => (
          <div key={i}>
            <EDTypography variant="h5">
              Fel vid kontakt med servern
            </EDTypography>
            <EDTypography variant="subtitle1">
              {props.errorMessage}
            </EDTypography>
            <ServerErrorView error={error} />
          </div>
        ))}
      </EDPopover>
    </EDView>
  );
};

export default ServerErrorSimple;
